import React from 'react';

const TimelineStep = ({ number, label, title, description, isLast }) => (
  <div className="timeline-step">
    <div className="timeline-step-badge">{number}</div>
    <div className="timeline-step-content">
      <div className="timeline-step-label">{label}</div>
      <h3 className="timeline-step-title">{title}</h3>
      <p className="timeline-step-description">{description}</p>
    </div>
    {!isLast && <div className="timeline-connector"></div>}
  </div>
);

const TimelineSection = () => (
  <section className="timeline-section">
    <div className="section-container">
      <h2 className="section-headline">What Happens Next</h2>
      <p className="section-supporting-text">
        A clear 3-step process that turns frustration into a simple, apples to apples decision.
      </p>
      <div className="timeline-steps">
        <TimelineStep
          number="1"
          label="STEP 1"
          title="Consultation"
          description="We review your current PEO setup, what's working, and where call center delays or surprise charges keep showing up."
        />
        <TimelineStep
          number="2"
          label="STEP 2"
          title="Underwriting"
          description="We prepare a detailed cost analysis so you can see service differences and potential savings with transparent, itemized pricing."
        />
        <TimelineStep
          number="3"
          label="STEP 3"
          title="Proposal"
          description="You get a custom proposal with clear terms and quotes in days, not weeks, so you can decide with confidence."
          isLast
        />
      </div>
      <p className="timeline-closing">
        No pressure. No obligation. Just clarity on what switching could change.
      </p>
    </div>
  </section>
);

export default TimelineSection;
